var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3767",
    transform: "rotate(90 907 -522)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3797",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1429 379)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3802",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1429 383)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3798",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1433 379)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3801",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1433 383)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3799",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1437 379)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3800",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1437 383)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.541194da.svg";
export { ForwardRef as ReactComponent };